import { useTranslation } from '@kostbar/i18n'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { formatRelativeTime } from '@/shared/utils/format-date'

interface EdgeStatusBadgeProps {
  online: boolean
  lastSeen: string | null
}

export function EdgeStatusBadge({ online, lastSeen }: EdgeStatusBadgeProps) {
  const { t: tEdges } = useTranslation('edges')
  if (online) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Badge
              variant="default"
              className="bg-green-600 hover:bg-green-700"
            >
              {tEdges('status.online')}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            {lastSeen
              ? tEdges('status.lastSeen', {
                  time: formatRelativeTime(lastSeen),
                })
              : tEdges('status.activeNow')}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Badge variant="destructive">{tEdges('status.offline')}</Badge>
        </TooltipTrigger>
        <TooltipContent>
          {lastSeen
            ? tEdges('status.lastSeen', {
                time: formatRelativeTime(lastSeen),
              })
            : tEdges('status.neverConnected')}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
